import { getAllNotifications } from 'services/notifications.service';
import { create } from 'zustand';

export const getNotifications = async ({ limit = 20, offset = 0 }) => {
    const res = await getAllNotifications({ limit, offset });
    if (res.status) {
        return res.entity;
    }
    return [];
};

export const useNotificationStore = create((set) => ({
    notifications: [],
    totalNotification: 0,
    fetchNotifications: async ({ limit, offset }) => {
        const notificationData = await getNotifications({ limit, offset });
        set((state) => ({
            notifications: [...(offset === 0 ? [] : state.notifications), ...(notificationData?.rows ?? [])],
            totalNotification: notificationData?.count ?? 0
        }));
    }
    // updateNotification: (notificationId) => set({
    //     notifications: state.notifications.map((notification) => {
    //         if (notification.id === notificationId) notification.read = true;
    //         return notification;
    //     })
    // })
}));
